"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeCanvas = void 0;
var React = _interopRequireWildcard(require("react"));
var _qrcode = require("qrcode");
var styles = _interopRequireWildcard(require("./QRCode.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const QRCodeCanvas = _ref => {
  let {
    id,
    text,
    width,
    color
  } = _ref;
  React.useEffect(() => {
    (0, _qrcode.toCanvas)(text, {
      errorCorrectionLevel: 'Q',
      width,
      color,
      margin: 0
    }, function (err, canvas) {
      if (err) {
        throw err;
      }
      const container = document.getElementById(id);
      container?.appendChild(canvas);
    });
  }, [text, width, color, id]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: styles['container']
  });
};
exports.QRCodeCanvas = QRCodeCanvas;